import { ApplicationIds } from "@next-platform/packages-ts-types";
export const LEGACY_SHARED_APPS = new Set([ApplicationIds.SPICYCHAT, ApplicationIds.PIXELCHAT]);
/**
 * Partner apps that don't use Kinde and have their own external authentication.
 * These apps don't need user ID namespacing as they manage their own user identity.
 * - ADULTTIME, EVIL_ANGEL, ASG_MAX: Use partner authentication
 * - GPTGIRLFRIEND: Uses Clerk authentication
 */
export const PARTNER_APPS = new Set([
    ApplicationIds.ADULTTIME,
    ApplicationIds.EVIL_ANGEL,
    ApplicationIds.ASG_MAX,
    ApplicationIds.GPTGIRLFRIEND,
]);
